import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function applyTheme(mode) {
  document.documentElement.classList.toggle("dark", mode === "dark");
  localStorage.setItem("ylms-theme", mode);
}

export function ThemeToggle() {
  const [mode, setMode] = useState(() => localStorage.getItem("ylms-theme") || "light");
  useEffect(() => { applyTheme(mode); }, [mode]);
  return (
    <button type="button" data-testid="theme-toggle" onClick={() => setMode(mode === "dark" ? "light" : "dark")} title={mode === "dark" ? "Mode terang" : "Mode gelap"}
      className="grid h-9 w-9 place-items-center rounded-full border border-slate-200 bg-white text-slate-600 hover:border-sky-400 hover:text-[color:var(--brand-blue)] transition-colors dark:bg-slate-800 dark:border-slate-700 dark:text-amber-300">
      {mode === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
